/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFhir = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15.284 7.806c.556.466 1.407 2.99 1.658 4.942.228 1.763.064 2.915-.745 5.226.466-.167 1.203-1.019 1.803-2.012-.047.303-.084.609-.143.909-.397 1.996-1.278 3.628-3.063 4.482-.618.296-1.315.393-1.977.58-.095.027-.192.045-.288.067h-.266c-.622-1.186-.975-2.445-.876-3.825.062-.856.288-1.648.737-2.363.53-.846 1.071-1.685 1.573-2.55.773-1.336 1.332-2.77 1.523-4.348.045-.369.045-.744.064-1.108z" />
        <path d="m14.348 5.015.258-1.652.056.01c-.06.483-.13.965-.173 1.45-.03.328-.082.675-.019.987.524 2.56-.084 4.822-1.46 6.912-.572.87-1.132 1.758-1.6 2.695-.78 1.56-.983 3.232-.542 4.96.096.376.272.729.425 1.128-1.801-1.207-3.163-2.733-3.467-5.112-.2-1.567.187-3 .794-4.393.701-1.61 1.744-2.95 2.82-4.267.766-.937 1.428-1.954 1.578-3.235.078-.675.053-1.365.069-2.05.003-.136-.017-.274-.027-.411L13.17 2l1.178 3.015z" />
        <path d="M10.597 7.658c-.403.534-.829 1.05-1.203 1.606-.503.747-1.004 1.5-1.436 2.295-1.126 2.074-1 4.232-.235 6.39.23.65.585 1.249.893 1.892a8.451 8.451 0 0 1-1.626-1.975c-.524-.881-.884-1.827-.938-2.89-.004-.07-.034-.137-.052-.205v-.434c.189-.711.325-1.447.58-2.13.357-.959.959-1.756 1.67-2.444.713-.687 1.44-1.357 2.163-2.033a.232.232 0 0 1 .184-.072z" />
      </g>
    </g>
  </Icon>
);
export { SvgFhir as Fhir };
